import { useGetIdentifiedSymptoms } from '@/api/identified-symptom/identified-symptom.hooks';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { AddIdentifiedSymptom } from './AddIdentifiedSymptom';
import { IdentifiedSymptomList } from './IdentifiedSymptomList';

export const IdentifiedSymptomManagement = () => {
  const { identifiedSymptoms, isLoading, isError, refetch } =
    useGetIdentifiedSymptoms();

  if (isLoading) return <LoadingScreen />;
  if (isError) return <ErrorScreen />;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <p className="text-sm text-zinc-500">
          {identifiedSymptoms.length} entrée
          {identifiedSymptoms.length !== 1 ? 's' : ''}
        </p>
        <AddIdentifiedSymptom refetch={refetch} />
      </div>

      {identifiedSymptoms.length === 0 ? (
        <p className="text-gray-500 text-center mt-12">
          Aucun symptôme identifié pour le moment.
        </p>
      ) : (
        <IdentifiedSymptomList items={identifiedSymptoms} refetch={refetch} />
      )}
    </div>
  );
};
